export default "__VITE_ASSET__CkNZWwMU__"